import { Instance, SnapshotOut } from 'mobx-state-tree';
import CollectionMapProcessor from '~/mst/models/abstract/collection_map_processor';
import model from './model';
import views from './views';
import actions from './actions';

const CertificatesStore = model.views(views).actions(actions);

export interface ICertificatesStore extends Instance<typeof CertificatesStore> {}
export interface ICertificatesStoreSnapshot extends SnapshotOut<typeof CertificatesStore> {}

export default CollectionMapProcessor(CertificatesStore);
